module.exports = __webpack_public_path__ + "img/xxkw_1-1.f2c05046.jpg";